module.exports = __webpack_public_path__ + "static/media/avatar.d1a51d81.png";